import React, { useContext, useEffect, useState } from "react";
import InputField from "../../../components/form/elements/InputField";
import { handleInputChange } from "../../../services/formServices";
import { isMultiYear } from "../../../services/defaultSettings";
import { years } from "../../../services/yearSevices";
import Container from "../../../components/ui/Container";
import auth from "../../../services/authServices";
import http from "../../../services/httpServices";
import AuthContext from "../../../context/AuthContext";
import { isEmptyObject } from "jquery";
import SubjectCard from "../../../components/NewUi/subjectCard/SubjectCard";
import SectionHeaderTitle from "../../../components/ui/SectionHeaderTitle";
import TeacherLine from "../../../components/NewUi/teacherHorizontal/TeacherLine";
import Card from "../../../components/NewUi/featureCard/Card";
import RetroCardSection from "../../../components/ui/RetroCardSection";
import LoadingIcon from "../../../components/ui/LoadingIcon";
import CenterIcon from "../../../components/ui/CenterIcon";
import Categorie from "./Categorie";
import Button from "../../../components/ui/Button";
import { isObjectEmpty } from "../../../utils/objects";
import { useLanguage } from "../../../context/LanguageContext";
import { ReactComponent as QuranIcon } from "../../../assets/telawah-assets/quranIconBtn.svg";

const initialState = {
    year: 3,
    subject_id: 0,
};
const useFetchedCourses = (data, user) => {
    const [courses, setCourses] = useState(false);
    const [isCoursesFetchingLoading, setIsCoursesFetchingLoading] = useState(true);
    const [isCoursesFetchingError, setIsCoursesFetchingError] = useState(false);

    const getCourses = async () => {
        setIsCoursesFetchingLoading(true);
        try {
            const token = auth.getToken();
            const config = auth.getAuthConfig(token);
            const { data: response } = await http.get(
                `/api/sellables/year/${!isObjectEmpty(user) ? user.year : data.year}`,
                config
            );
            setCourses(response);
            setIsCoursesFetchingLoading(false);
        } catch (error) {
            setIsCoursesFetchingError(true);
            setIsCoursesFetchingLoading(false);
        }
    };
    const handleFetchedCourses = () => {
        getCourses();
    };

    return {
        courses,
        isCoursesFetchingLoading,
        isCoursesFetchingError,
        getCourses,
        handleFetchedCourses,
    };
};

const useFetchedSubjectsByYear = (data, user) => {
    const [subjectLoading, setIsSubjectsLoading] = useState(false);
    const [subjects, setSubjects] = useState([]);
    const getSubjects = async () => {
        setIsSubjectsLoading(true);
        const token = auth.getToken();
        const config = auth.getAuthConfig(token);

        const { data: response } = await http.get(
            // `/api/years/${!isObjectEmpty(user) ? user.year : data.year}/subjects/options`,
            `/api/subjects/options`,
            config
        );
        setSubjects(response);
        setIsSubjectsLoading(false);
    };
    return { subjects, getSubjects, subjectLoading };
};
const SubjectsSection = () => {
    const [data, setData] = useState(initialState);
    const [seeMore, setSeeMore] = useState(false);
    const authUser = auth.getUser() || {};
    const { user } = useContext(AuthContext);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const { language } = useLanguage();

    const { subjects, getSubjects, subjectLoading } = useFetchedSubjectsByYear(data, authUser);
    const {
        courses,
        isCoursesFetchingLoading,
        isCoursesFetchingError,
        getCourses,
        handleFetchedCourses,
    } = useFetchedCourses(data, authUser);

    useEffect(() => {
        if (!courses) {
            getCourses();
        }
        if (courses) {
            setFilteredCourses(courses);
        }
    }, [courses]);

    // useEffect(() => {
    //     getSubjects();
    // }, [data.year]);

    useEffect(() => {
        if (!courses) return;

        if (courses && !data.subject_id && data.course_status === "all_courses") {
            setFilteredCourses(courses);
            return;
        }
        let filtered = [...courses];

        if (data.subject_id && data.subject_id != 0) {
            filtered = filtered.filter((course) => course.subject_id == data.subject_id);
        }
        if (data.year && data.year != 0) {
            filtered = filtered.filter((course) => course.year == data.year);
        }
        filtered.sort((a, b) => {
            if (a.subscriptions_count === 1 && b.subscriptions_count !== 1) return -1;
            if (a.subscriptions_count !== 1 && b.subscriptions_count === 1) return 1;
            return 0;
        });
        setFilteredCourses(filtered);
    }, [data, courses]);

    useEffect(() => {
        getSubjects();
    }, []);

    useEffect(() => {
        if (!isEmptyObject(user) && user.year && user.year != data.year) {
            setData({
                ...data,
                year: user.year,
            });
            getSubjects();
        }
    }, [user]);

    const content = {
        SectionHeaderTitle: {
            en: "Our Latest Courses",
            ar: "أحدث الدورات",
            de: "Unsere neuesten Kurse",
        },
        subtitle: {
            en: "What are you looking for?",
            ar: "نفسك في مين ..؟",
            de: "Wonach suchst du?",
        },
        description: {
            en: "Simply choose your preferred subject to explore the available courses. We're here to guide you every step of the way!",
            ar: "اختر مستواك وفئة الدورة التي تناسبك، لإظهار أحدث الدورات التي تناسب احتياجك بشكل أسهل وأسرع!",
            de: "Wähle einfach dein bevorzugtes Fach, um die verfügbaren Kurse zu erkunden. Wir begleiten dich auf jedem Schritt!",
        },
        selectSubject: {
            en: "Choose your favorite content",
            ar: "أختار المحتوي المفضل لديك",
            de: "Wähle dein bevorzugtes Fach",
        },
        loadingSubjects: {
            en: "Loading subjects...",
            ar: "يتم الآن تحميل المحتويات العلمية ...",
            de: "Fächer werden geladen...",
        },
        errorCourses: {
            en: "An error occurred while loading the courses",
            ar: "حدث خطأ اثناء تحميل الكورسات",
            de: "Beim Laden der Kurse ist ein Fehler aufgetreten",
        },
        loadingCourses: {
            en: "Loading courses...",
            ar: "يتم الآن تحميل الكورسات",
            de: "Kurse werden geladen...",
        },
        noCourses: {
            en: "No courses available",
            ar: "لا يوجد كورسات متاحة",
            de: "Keine Kurse verfügbar",
        },
        showMore: {
            en: "Show more courses",
            ar: "عرض المزيد من الكورسات",
            de: "Mehr Kurse anzeigen",
        },
        showLess: {
            en: "Show less",
            ar: "عرض أقل",
            de: "Weniger anzeigen",
        },
    };

    return (
        <div
            className={`mb-20 mt-[8rem] px-4 md:px-20 flex flex-col space-y-20 relative overflow-hidden ${
                language !== "ar" ? "en" : "ar"
            }`}
            id="courses"
        >
            <div
                className={`px-0 md:px-20 text-center ${
                    language === "ar" ? "md:text-right" : "md:text-left"
                }`}
            >
                <SectionHeaderTitle title={content.SectionHeaderTitle[language]} />

                <p className="text-gray-500 dark:text-gray-200 smooth w-full text-lg md:text-xl md:max-w-[500px]">
                    {content.description[language]}
                </p>
            </div>

            <Container>
                <div className="flex items-center justify-between flex-col space-y-5">
                    {/* <div className="px-10 py-3 rounded-md border border-solid border-gray-400 smooth clr-text-primary">
                        {isMultiYear && (isEmptyObject(user) || !user.year) && (
                            <InputField
                                onChange={handleInputChange}
                                data={data}
                                setData={setData}
                                type="select"
                                options={years}
                                className="min-w-[250px]"
                                id="year"
                                placeholder={
                                    language === "ar" ? "اختر الصف الدراسي" : "Select Year"
                                }
                            />
                        )}
                    </div> */}

                    <div className="flex-center-both flex-col gap-2 pt-2 bg-gray-50 dark:bg-slate-800 rounded-md shadow-md px-0 md:px-4 py-2">
                        <span className="clr-text-primary text-lg text-center bg-ashGray-100 border border-ashGray-500/50 px-0 md:px-2 py-1 shadow-sm rounded-xl">
                            {content.selectSubject[language]}
                        </span>
                        {!subjectLoading ? (
                            <div className={"flex-center-both"}>
                                <div
                                    className={`grid grid-cols-1 ${
                                        isEmptyObject(user) || !user.year
                                            ? "md:grid-cols-2"
                                            : " md:grid-cols-1"
                                    } gap-4 px-3 md:px-10 py-4 rounded-2xl smooth`}
                                >
                                    {isMultiYear && (isEmptyObject(user) || !user.year) ? (
                                        <InputField
                                            onChange={handleInputChange}
                                            data={data}
                                            setData={setData}
                                            type="select"
                                            options={years}
                                            id="year"
                                            placeholder={
                                                language === "ar"
                                                    ? "اختر المرحلة الدراسية"
                                                    : language === "de"
                                                    ? "Wähle die Schulstufe"
                                                    : "Choose your grade"
                                            }
                                            className="min-w-[300px]"
                                        />
                                    ) : (
                                        ""
                                    )}
                                    <InputField
                                        onChange={handleInputChange}
                                        data={data}
                                        setData={setData}
                                        type="select"
                                        options={subjects}
                                        id="subject_id"
                                        placeholder={
                                            language === "ar"
                                                ? "اختر المحتوى"
                                                : language === "de"
                                                ? "Wähle den Inhalt"
                                                : "Choose content"
                                        }
                                        className="min-w-[300px]"
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="flex-center-both">
                                <LoadingIcon />
                                <span>{content.loadingSubjects[language]}</span>
                            </div>
                        )}
                    </div>
                </div>
            </Container>

            <div>
                {isCoursesFetchingError ? (
                    <div className="p-5 bg-red-100 rounded-md text-red-600 text-center">
                        {content.errorCourses[language]}
                    </div>
                ) : isCoursesFetchingLoading ? (
                    <div className="p-5 text-blue-500 text-center">
                        {content.loadingCourses[language]}
                    </div>
                ) : (
                    <>
                        <Categorie
                            className={`flex-center-both flex-wrap gap-7 ${
                                language === "ar" ? "space-x-reverse" : ""
                            }`}
                            coursesList={seeMore ? filteredCourses : filteredCourses?.slice(0, 3)}
                            noCoursesPlaceholder={content.noCourses[language]}
                        />
                        {filteredCourses.length > 3 && (
                            <div className="flex justify-center my-8">
                                <Button
                                    className="flex justify-center my-8"
                                    onClick={() => setSeeMore((prev) => !prev)}
                                    color="germanRed"
                                >
                                    {seeMore
                                        ? content.showLess[language]
                                        : content.showMore[language]}
                                </Button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default SubjectsSection;
